export default {"src":"/_next/static/media/soc.a7bc69a7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};